'use client';

import React, { useEffect, useState } from 'react';
import handleJsonLd from '../data/handleJsonLd';

interface Props {
  jsonLd: string;
  isoDateModified?: string | null;
  isoDatePublished?: string | null;
}

export default function Schema({ jsonLd, isoDateModified, isoDatePublished }: Props) {
  const [scriptProps, setScriptProps] = useState<Record<string, any> | null>(null);
  useEffect(() => {
    setScriptProps(handleJsonLd({ jsonLdRaw: jsonLd, isoDateModified, isoDatePublished }));
  }, [jsonLd, isoDateModified, isoDatePublished]);

  return scriptProps && <script {...scriptProps} />;
}
